import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=747da586&scoped=true"
import script from "./Hero.js?vue&type=script&lang=js&external"
export * from "./Hero.js?vue&type=script&lang=js&external"
import style0 from "./Hero.scss?vue&type=style&index=0&id=747da586&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747da586",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Image/Image.vue').default,HotTitle: require('/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default})
